import { Link } from "react-router-dom";
import { ContentContainer, PageSection } from "./common";
import { LOGOS, LOGO_DIMENSIONS } from "../lib/utils";

export function Footer() {
  return (
    <footer className="w-full">
      <PageSection background="gray-900">
        <ContentContainer maxWidth="standard">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-16 mb-12">
            {/* Left Side - Logos and Description */}
            <div className="lg:col-span-2 flex flex-col items-center lg:items-start">
              {/* Logos */}
              <div className="flex flex-col sm:flex-row items-center lg:items-start gap-6 sm:gap-8 mb-6">
                <Link
                  to="https://www.legitscript.com/websites/?checker_keywords=axentrahealth.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Verify LegitScript Approval for www.axentrahealth.com"
                  className="flex items-center justify-center group"
                >
                  <img
                    src="/images/Legit-script.png"
                    alt="LegitScript Certification"
                    className="w-auto h-12 sm:h-16 lg:h-20 max-w-[150px] object-contain transform group-hover:scale-105 transition-all duration-500"
                  />
                </Link>
                <img
                  src={LOGOS.footer}
                  alt="Axentra Logo"
                  className="h-12 sm:h-16 lg:h-20"
                  width={LOGO_DIMENSIONS.footer.width}
                  height={LOGO_DIMENSIONS.footer.height}
                  loading="eager"
                />
              </div>

              {/* Company Description */}
              <p className="text-gray-400 text-sm leading-relaxed text-center lg:text-left">
                Axentra Health — The compliant, turnkey infrastructure powering
                the next era of wellness, longevity, and performance medicine.
              </p>
            </div>

            {/* Right Side - Navigation Links */}
            <div className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 place-items-center md:place-items-start">
              {/* Main Pages */}
              <div className="flex flex-col items-center md:items-start w-fit">
                <h3 className="font-bold text-lg mb-4 text-center md:text-left">
                  Main Pages
                </h3>
                <ul className="space-y-3 flex flex-col items-center md:items-start">
                  <li>
                    <Link
                      to="/"
                      className="text-gray-400 hover:text-white text-sm transition-colors"
                    >
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/about"
                      className="text-gray-400 hover:text-white text-sm transition-colors"
                    >
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/contact"
                      className="text-gray-400 hover:text-white text-sm transition-colors"
                    >
                      Contact Us
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/pricing"
                      className="text-gray-400 hover:text-white text-sm transition-colors"
                    >
                      Pricing
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/safety"
                      className="text-gray-400 hover:text-white text-sm transition-colors"
                    >
                      Safety
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Solutions */}
              <div className="flex flex-col items-center md:items-start w-fit">
                <h3 className="font-bold text-lg mb-4 text-center md:text-left">
                  Solutions
                </h3>
                <ul className="space-y-3 flex flex-col items-center md:items-start">
                  <li>
                    <Link
                      to="/solutions"
                      className="text-gray-400 hover:text-white text-sm transition-colors"
                    >
                      All Solutions
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/solutions/chiropractors"
                      className="text-gray-400 hover:text-white text-sm transition-colors"
                    >
                      Chiropractors
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/solutions/fitness"
                      className="text-gray-400 hover:text-white text-sm transition-colors"
                    >
                      Fitness & Nutrition
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/solutions/supplements"
                      className="text-gray-400 hover:text-white text-sm transition-colors"
                    >
                      Supplement Stores
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/solutions/clinics"
                      className="text-gray-400 hover:text-white text-sm transition-colors"
                    >
                      Medical Clinics
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/solutions/entrepreneurs"
                      className="text-gray-400 hover:text-white text-sm transition-colors"
                    >
                      Entrepreneurs
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Resources */}
              <div className="flex flex-col items-center md:items-start w-fit">
                <h3 className="font-bold text-lg mb-4 text-center md:text-left">
                  Resources
                </h3>
                <ul className="space-y-3 flex flex-col items-center md:items-start">
                  <li>
                    <Link
                      to="/blog"
                      className="text-gray-400 hover:text-white text-sm transition-colors"
                    >
                      Blog
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/news"
                      className="text-gray-400 hover:text-white text-sm transition-colors"
                    >
                      News
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/careers"
                      className="text-gray-400 hover:text-white text-sm transition-colors"
                    >
                      Careers
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Bottom Section */}
          <div className="border-t border-gray-800 pt-6 flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
            <p className="text-gray-400 text-sm text-center sm:text-left">
              © {new Date().getFullYear()} Axentra Health. All rights reserved.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6">
              <Link
                to="/terms-and-conditions"
                className="text-gray-400 hover:text-white text-sm transition-colors"
              >
                Terms and Conditions
              </Link>
              <div className="h-4 w-px bg-gray-700" />
              <div className="flex items-center gap-4">
                <Link
                  to="https://www.facebook.com/profile.php?id=61586327245057"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors"
                  aria-label="Facebook"
                >
                  <svg
                    className="h-5 w-5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
                  </svg>
                </Link>
                <Link
                  to="https://instagram.com/axentrahealthcorp"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors"
                  aria-label="Instagram"
                >
                  <svg
                    className="h-5 w-5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                  </svg>
                </Link>
                <Link
                  to="https://linkedin.com/company/axentrahealth"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors"
                  aria-label="LinkedIn"
                >
                  <svg
                    className="h-5 w-5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                  </svg>
                </Link>
                <Link
                  to="https://www.youtube.com/@Axentra-Health"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors"
                  aria-label="YouTube"
                >
                  <svg
                    className="h-5 w-5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </ContentContainer>
      </PageSection>
    </footer>
  );
}
